import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-close',
  templateUrl: './dialog-close.component.html',
  styleUrls: ['./dialog-close.component.sass']
})
export class DialogCloseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
